import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

import "./index.css";     // ✅ for base styling
import "./styles.css";
import "./components/footer.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <div className="app-container">
        <div className="main-container"> {/* Responsive wrapper */}
          <App />
        </div>
      </div>
    </BrowserRouter>
  </HelmetProvider>
);
